import { loginSuccess, logout, setclub, setEventId, setUsersClub, updateOverviewStatus, updateProfileStatus } from "../actions/authActions";

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  eventId: string | null;
  user: any | null;
  modules: any | null;
  isLoggedIn: boolean;
  usersClub: any;
  club: any;
}

const initialState: AuthState = {
  isAuthenticated: localStorage.getItem("token") ? true : false,
  token: localStorage.getItem("token") || null,
  eventId: localStorage.getItem("eventId") || null,
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")!)
    : null,
  modules: localStorage.getItem("modules")
    ? JSON.parse(localStorage.getItem("modules")!)
    : null,
  isLoggedIn: false,
  usersClub: localStorage.getItem("usersClub")
    ? JSON.parse(localStorage.getItem("usersClub")!)
    : null,
  club: localStorage.getItem("selectedClub")
    ? JSON.parse(localStorage.getItem("selectedClub")!)
    : null
  // usersClub: JSON.parse(localStorage.getItem("usersClub") || "[]"),
};

type AuthAction = ReturnType<typeof loginSuccess | typeof logout | typeof updateProfileStatus | typeof setUsersClub | typeof setEventId | typeof setclub | typeof updateOverviewStatus>;

const authReducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        isLoggedIn: true,
        token: action.payload.token,
        user: action.payload.user,
        modules: action.payload.modules,
      };

    case 'LOGOUT':
      return {
        isAuthenticated: false,
        token: null,
        isLoggedIn: false,
        user: null,
        modules: null,
        usersClub: null,
        eventId: null,
        club: ""
      };

    case "UPDATE_PROFILE_STATUS":
      return {
        ...state,
        user: {
          ...state.user,
          profileStatus: action.payload,
        },
      };

    case "UPDATE_OVERVIEW_STATUS":
      return {
        ...state,
        user: {
          ...state.user,
          userSetting: {
            ...state.user?.userSetting,
            [action.payload.key]: action.payload.value,
          },
        },
      };

    case "SET_USERS_CLUB":
      return {
        ...state,
        usersClub: action.payload,
      };
    case 'SET_CLUB':
      return {
        ...state,
        club: action.payload,
      };
    case "SET_EVENT_ID":
      return {
        ...state,
        eventId: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
